import { Redirect } from 'expo-router';

/** Keep legacy Events links working now that Home owns the complete event feed. */
export default function LegacyEventsRedirect() {
  return <Redirect href="/app/home" />;
}
